import Search from './Search';

export const PAGE_SEARCH = '/search';

export default Search;
